import React from 'react';
import type { WorkflowPhase } from '../types';

export interface WorkflowNavigationProps {
  currentPhase: WorkflowPhase;
  onPhaseChange: (phase: WorkflowPhase) => void;
}

interface PhaseConfig {
  id: WorkflowPhase;
  step: number;
  label: string;
  sublabel: string;
}

const PHASES: PhaseConfig[] = [
  { id: 'define', step: 1, label: 'DEFINE', sublabel: 'Site & Geometry' },
  { id: 'model', step: 2, label: 'MODEL', sublabel: 'Physics & Numerics' },
  { id: 'run', step: 3, label: 'RUN', sublabel: 'Validation & Execution' },
  { id: 'analyze', step: 4, label: 'ANALYZE', sublabel: 'Results & Investigation' }
];

export const WorkflowNavigation: React.FC<WorkflowNavigationProps> = ({
  currentPhase,
  onPhaseChange
}) => {
  return (
    <nav className="ssw-workflow-nav" aria-label="Simulation Workflow Phases">
      <div className="ssw-workflow-phases" role="tablist">
        {PHASES.map((phase) => {
          const isActive = currentPhase === phase.id;
          return (
            <button
              key={phase.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              id={`ssw-phase-tab-${phase.id}`}
              className={`ssw-phase-step-btn ${isActive ? 'is-active' : ''}`}
              onClick={() => onPhaseChange(phase.id)}
            >
              <span className="ssw-phase-badge">{phase.step}</span>
              <div className="ssw-phase-labels">
                <span className="ssw-phase-title">{phase.label}</span>
                <span className="ssw-phase-subtitle">{phase.sublabel}</span>
              </div>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default WorkflowNavigation;
